import {useInfiniteQuery} from 'react-query';
import useInfiniteScroll from '../../../../utilities/hooks/useInfiniteScroll';
import {getListSubProducts} from './getListSubProducts';
import {IGetListSubBrandPayload} from './types';

const useGetListSubBrand = (payload: IGetListSubBrandPayload) => {
  const {
    data: rawData,
    isLoading,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useInfiniteQuery(
    ['list-sub-brand', payload],
    async ({pageParam = 1}) => getListSubProducts({pageParam, payload}),
    {
      getNextPageParam: (lastPage, allPage) => {
        if (!lastPage.next) return undefined;
        return allPage.length + 1;
      },
    },
  );

  const data = rawData?.pages.flatMap(page => page.results);

  const loaderRef = useInfiniteScroll({
    isLoading,
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
  });

  return {
    data,
    isLoading,
    loaderRef,
    isFetchingNextPage,
  };
};

export default useGetListSubBrand;
